import { createBrandGraphic } from "@groundspark/brand";
import { element, heading } from "@groundspark/browser-ui";
import type { BrowserAuthManager } from "./auth";
import { authenticationForm } from "./form";

interface AuthenticationScreenOptions {
  readonly appName: string;
  readonly subtitle: string;
  readonly error?: string | null;
}

export function authenticationScreen(
  auth: BrowserAuthManager,
  onSignedIn: () => Promise<void>,
  { appName, subtitle, error }: AuthenticationScreenOptions,
): HTMLElement {
  const logo = element("a", "brand-lockup", createBrandGraphic(document, { tone: "light" }));
  logo.href = "https://groundspark.app/";
  logo.setAttribute("aria-label", "Groundspark home");

  const screen = element(
    "main",
    "auth-screen",
    element(
      "section",
      "auth-card",
      logo,
      heading(1, appName),
      element("p", "auth-card__subtitle", subtitle),
      authenticationForm(auth, onSignedIn, error),
    ),
  );
  screen.id = "main-content";
  screen.tabIndex = -1;
  return screen;
}
